import { useEffect } from 'react';

import { ColumnsType } from 'antd/lib/table';

import { message, Tag } from 'antd';
import { User, UsersGroup, UserStatusType } from '../../types';
import { GroupsRenderer } from './groupsRenderer';
import { UsersRenderer } from './usersRenderer';
import {
  getUserStatusLabel,
  getUserStatusLabelColor,
  maskCPF,
} from '../../utils/utils';
import { useUpdateUserStatusMutation } from '../../services/usersApi';

export function columns(
  selectUser: (user: User) => void,
  refetch: () => void
): ColumnsType<Record<string, any>> {
  //
  const [
    updateUserStatus,
    { isSuccess: isSuccessUpdateUserStatus, isError: isErrorUpdateUserStatus },
  ] = useUpdateUserStatusMutation();

  const onChangeStatus = (user: any, status: UserStatusType) => {
    updateUserStatus({
      status,
      id: user?.id,
    });
  };

  useEffect(() => {
    if (isSuccessUpdateUserStatus) {
      message.success('Usuário atualizado sucesso!');
      window.location.reload();
    }

    if (isErrorUpdateUserStatus) {
      message.error('Erro ao atualizar Usuário!');
    }
  }, [isSuccessUpdateUserStatus, isErrorUpdateUserStatus]);

  return [
    {
      title: <div className="show-amount">Usuários</div>,
      dataIndex: 'user',
      key: 'user',
      render: (user: User) => <UsersRenderer user={user} />,
      sorter: {
        compare: (a: any, b: any) =>
          a.user.first_name.localeCompare(b.user.first_name),
        multiple: 1,
      },
      defaultSortOrder: 'ascend' as const,
      showSorterTooltip: false,
    },
    {
      title: 'CPF',
      key: 'user',
      render: (user) => {
        if (user.user?.cpf) {
          return <>{maskCPF(user.user?.cpf)}</>;
        }
        return <> - </>;
      },
    },
    {
      title: 'Estado',
      key: 'user',
      render: (user) => {
        if (user.status) {
          return (
            <Tag color={getUserStatusLabelColor(user.status)}>
              {getUserStatusLabel(user.status)}
            </Tag>
          );
        }
        return <> - </>;
      },
    },
    {
      title: 'Empresa',
      dataIndex: ['company', 'name'],
      key: 'company',
      render: (text: string) => <span>{text}</span>,
      sorter: {
        compare: (a: any, b: any) => a.company.localeCompare(b.company),
        multiple: 1,
      },
      showSorterTooltip: false,
    },
    {
      title: 'Grupos a que pertence',
      dataIndex: 'groups',
      key: 'groups',
      render: (groups: Array<UsersGroup>, record: any) => (
        <GroupsRenderer
          selectUser={selectUser}
          record={record}
          groups={groups}
        />
      ),
    },
  ];
}
